import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lp2-group-class-state-sign-up-confirm',
  styleUrls: ['./group-class-state.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="divider mt-2 mt-sm-3"></div>
    <div class="d-flex flex-column">
      <p class="flex-1 mb-2 mt-2 mb-sm-3 mt-sm-3 ml-sm-4 fw-bold state-text text-center text-xl-start">
        {{ stateTextKey | translate }}
      </p>
      <div class="d-flex flex-wrap justify-content-center">
        <button class="btn btn-accent-text font-weight-bold sign-up-button mr-3" (click)="onCancel($event)">
          {{ 'cancelCaption' | translate }}
        </button>
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class GroupClassStateSignUpConfirmComponent {
  @Input() stateTextKey: string;
  @Output() cancel = new EventEmitter();

  public onCancel(event: Event) {
    this.cancel.emit(event);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-sign-up-confirm.component.ts